import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import createBarkerSvg from '@sparta.credit-cards.utilities/barker-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"large") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"medium") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"language-map\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"language") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":36},"end":{"line":1,"column":53}}}))
    + "\"></div>\r\n<div class=\"spa-header\">\r\n  <button id=\"ModalCompTogActCls\" class=\"spa-icon icon-close spa-ui-layer-close \" href=\"javascript:void(0);\">\r\n    <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"close") : stack1), depth0))
    + "</span>\r\n  </button>\r\n</div>\r\n<div class=\"compareContainer\" aria-live=\"polite\">\r\n  <ul class=\"compare\">\r\n    <li aria-live=\"polite\" aria-hidden=\"true\">\r\n      <div class=\"card-placeholder\"></div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"remove") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":11,"column":33}}}))
    + "\r\n    </li>\r\n    <li aria-live=\"polite\" aria-hidden=\"true\">\r\n      <div class=\"card-placeholder\"></div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"remove") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":15,"column":33}}}))
    + "\r\n    </li>\r\n    <li aria-live=\"polite\" aria-hidden=\"true\">\r\n      <div class=\"card-placeholder\"></div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"remove") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":19,"column":6},"end":{"line":19,"column":33}}}))
    + "\r\n    </li>\r\n    <li aria-live=\"polite\" aria-hidden=\"true\">\r\n      <div class=\"card-placeholder\"></div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"remove") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":23,"column":6},"end":{"line":23,"column":33}}}))
    + "\r\n    </li>\r\n  </ul>\r\n  "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"compareSmall") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":26,"column":2},"end":{"line":26,"column":35}}}))
    + "\r\n  "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"compareMediumUp") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":27,"column":2},"end":{"line":27,"column":38}}}))
    + "\r\n</div>\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":0},"end":{"line":34,"column":17}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/compare-cc-module",
  "version": "5.0.2",
  "id": "compareCcModule",
  "containerID": "creditCardsCompareCcModule",
  "moduleName": "credit-cards-compare-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "compare-cc-module",
  "data": {
    "init": "compareCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        layerContent,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    layerContent,
    json
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/barker-utility": "^1.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global spaParams sparta */

/**
 * maxCompare
 * @description Max compare items based on viewport
 */
const maxCompare = {
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
  xxlarge: 4
};
let hasModuleInit = false;

/*
 * compare-cc-module
 * module_js_id: compareCcModuleJS
 *
 * Copyright (c) 2017-12-5
 */

/**
 * @export
 * @class compareCcModuleJS
 * @extends {Module}
 */
class compareCcModuleJS extends Module {
  /**
   * constructor
   * @param {object} options - options passed for constructor
   * @param {object} context - context passed for constructor
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;

    // Cache the text remove to reuse as a template string later via resets
    this.adaTextRemove = '';
    this.languageMap = Object.values(JSON.parse(target.querySelector('.language-map').dataset.jcr));
    this.compareItems = Array.from(target.querySelectorAll('ul.compare li'));
  }

  /**
   * init
   * @return {void}
   */
  init() {
    if (!hasModuleInit) {
      hasModuleInit = true;
      this.bindEvents();
      this.bindEventListeners();
      this.updateCompareBar(this.getData('hideCompareBar') === false);
      this.publishCompareData();
      this.checkLanguageMap();
    }
  }

  /**
   * bindEvents
   * @return {void}
   */
  bindEvents() {
    spartaEventsUtility.sub(creditCardUtility.EVENTS.compareUpdate, this.handleCompareUpdate.bind(this), true);
    spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, this.handleBreakpointChange.bind(this), true);
  }

  /**
   * bindEventListeners
   * @return {void}
   */
  bindEventListeners() {
    const {
      target
    } = this.settings;
    creditCardUtility.delegateEvent('click', '.remove', this.handleRemove.bind(this), false, target);
    creditCardUtility.delegateEvent('click', '#ModalCompTogActCls', () => {
      this.hideCompareBar();
    }, false, target);
  }

  /**
   * handleCompareUpdate
   *
   * @param {object} res response
   * @return {void}
   */
  handleCompareUpdate(res) {
    const {
      data
    } = res;
    const storeData = this.getData();
    if (!storeData) {
      const compare = [];
      compare.push(data);
      this.setData(compare);
      this.updateCompareBar();
      this.publishCompareData();
      return;
    }

    // filteredStoreData is required due to the fuzzy logic from sparta1 migration.
    // data is different between en and es,
    // en parent id is different that campaign id
    // es parent id is the same as the campaign id.
    const filteredStoreData = this.applyLanguageFilter(storeData);
    const filtered = filteredStoreData.slice(0).filter(camp => camp.campaign === data.campaign);

    // Removing
    if (storeData && filtered.length) {
      const idx = storeData.indexOf(filtered[0]);
      storeData.splice(idx, 1);
      this.setData(storeData);
    }

    // Adding
    if (storeData && !filtered.length) {
      // Check items in store
      const viewport = spartaMediaQueryUtility.getCurrentViewport().currentViewport;
      const max = maxCompare[viewport] || maxCompare.large;
      if (filteredStoreData.length >= max) {
        spartaUILayersUtility.openLayer('#ModalCompareMax');
        this.showCompareBar();
        this.publishCompareData();
        return;
      }
      storeData.push(data);
      this.setData(storeData);
    }
    this.updateCompareBar();
    this.publishCompareData();
  }

  /**
   * handleRemove
   * @param {object} e event
   * @return {void}
   */
  handleRemove(e) {
    e.preventDefault();
    const listItem = e.target.parentNode;
    const campaign = listItem.dataset.id;
    const filtered = this.getData().filter(item => item.campaign !== campaign);
    this.setData(filtered);
    this.updateCompareBar();
    this.publishCompareData();
  }

  /**
   * showCompareBar
   * @return {void}
   */
  showCompareBar() {
    this.settings.target.classList.add('active');
    this.setData(false, 'hideCompareBar');
  }

  /**
   * hideCompareBar
   * @return {void}
   */
  hideCompareBar() {
    this.settings.target.classList.remove('active');
    this.setData(true, 'hideCompareBar');
  }

  /**
   * updateCompareBar
   *
   * @param {string} show defaults true, show compare after update
   * @returns {void}
   */
  updateCompareBar(show = true) {
    this.resetCompareBar();
    const compareData = this.getData();
    if (!compareData) {
      return;
    }
    const filteredData = this.applyLanguageFilter(compareData);
    if (!filteredData.length) {
      this.hideCompareBar();
      return;
    }
    filteredData.forEach((item, idx) => {
      const listItem = this.compareItems[idx];
      if (listItem) {
        Object.assign(listItem.style, {
          backgroundImage: `url(${spaParams.siteParams.contentRoot}${item.image})`
        });
        listItem.classList.add('active');
        listItem.setAttribute("aria-hidden", "false");
        listItem.dataset.id = item.campaign;
        const adaEl = listItem.querySelector('.ada-hidden');
        const placeholderEl = listItem.querySelector('.card-placeholder');
        adaEl.innerHTML = this.adaTextRemove.replace('{CARD_NAME}', item.product);
        if (item.barkerPosition && item.barkerText) {
          placeholderEl.innerHTML = createBarkerSvg(item.barkerText, item.barkerPosition, null, item.barkerColor);
        }
      }
    });
    if (show) {
      this.showCompareBar();
    }
  }

  /**
   * resetCompareBar
   *
   * @returns {void}
   */
  resetCompareBar() {
    this.compareItems.forEach(compareItem => {
      const placeholder = compareItem.querySelector('.card-placeholder');
      const adaEl = compareItem.querySelector('.ada-hidden');

      // Remove the barker
      placeholder.innerHTML = '';
      if (!this.adaTextRemove) {
        this.adaTextRemove = adaEl.innerText;
      }
      Object.assign(compareItem.style, {
        backgroundImage: ''
      });
      compareItem.removeAttribute('data-id');
      compareItem.classList.remove('active');
      compareItem.setAttribute("aria-hidden", "true");
      adaEl.innerText = this.adaTextRemove;
    });
  }

  /**
   * getData
   * @param {string} key compare key
   * @return {string} value for key
   */
  getData(key = 'compare') {
    return spartaStoreUtility.getPersisted(key, 'sessionStorage');
  }

  /**
   * setData
   *
   * @description Writes store data via compare key and sessionStorage
   * @param {Array} compare List of campaigns
   * @param {String} key Key for store
   * @returns {void}
   */
  setData(compare = [], key = 'compare') {
    spartaStoreUtility.persist(key, compare, 'sessionStorage');
  }

  /**
   * publishCompareData
   * @returns {void}
   */
  publishCompareData() {
    spartaEventsUtility.pub(creditCardUtility.EVENTS.compareData, {
      campaigns: this.applyLanguageFilter(this.getData())
    });
  }

  /**
   * handleBreakpointChange
   *
   * @param {Object} res
   * @returns {void}
   */
  handleBreakpointChange(res) {
    const {
      data
    } = res;
    const storeData = this.getData();
    const filteredData = this.applyLanguageFilter(storeData);
    const max = maxCompare[data.viewport] || maxCompare.large;
    if (filteredData && filteredData.length > max) {
      // find the one to remove
      const toRemove = filteredData.slice(max);
      const filtered = storeData.filter(
      // eslint-disable-next-line comma-dangle
      check => toRemove.filter(remove => check.campaign === remove.campaign).length === 0);

      // reduce the stored data for the viewport
      this.setData(filtered);
      this.publishCompareData();
      this.updateCompareBar(false);
    }
  }

  /**
   * applyLanguageFilter
   *
   * @param {Object} data lang data
   * @returns {Object} card data
   */
  applyLanguageFilter(data) {
    if (!data) {
      return [];
    }
    const language = sparta.language === 'en' ? 'es' : 'en';
    const storedData = data.slice(0); // clone array to not mutate
    const languageMap = this.languageMap.slice(0); // clone array to not mutate

    // Map for campaign for current language
    storedData.map(card => {
      const campaignId = card.campaign.replace(/~e(?:n|s)_US/i, '');
      const mapped = languageMap.filter(
      // eslint-disable-next-line comma-dangle
      map => map[language] && map[language] === campaignId);
      if (mapped.length) {
        const newCampaignId = `${mapped[0][sparta.language]}~${sparta.language}_US`;
        Object.assign(card, {
          campaign: newCampaignId
        });
      }
      return card;
    });
    this.setData(storedData);

    // Only show for current language
    const filtered = storedData.filter(card => card.campaign.indexOf(`~${sparta.language}_US`) > -1);
    return filtered;
  }

  /**
   * checkLanguageMap
   *
   * @description Checks to see if a card from another language
   * shouldn't be displayed.
   * @returns {void}
   */
  checkLanguageMap() {
    const data = this.getData() || [];
    const filtered = this.applyLanguageFilter(data);
    if (filtered.length !== data.length && !this.getData('unavailableModalShown')) {
      spartaUILayersUtility.openLayer('#modalcardUnavailable');
      this.setData(true, 'unavailableModalShown');
    } else {
      this.setData(false, 'unavailableModalShown');
    }
  }
}
registerModuleClass({
  moduleClass: compareCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { compareCcModuleJS as default, moduleConfig };
